import {
  faHouse,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";

const northernMortgageOrgId: number = 1905265078;
const northernMortgageSubDomain: string = "northernmortgage";
const nameOfProduct: string = "Nm";
const secureRouteGroups: string[] = ["Northern"];

export const northernMortgageObject: SubdomainOrgIdObject = {
  orgID: northernMortgageOrgId,
  path: northernMortgageSubDomain,
};

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link
          to={`/${northernMortgageObject.path}/?productURL=pinboards&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHouse} />
            Home
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${northernMortgageObject.path}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${northernMortgageObject.path}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const northernMortgageRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${northernMortgageObject.path}/contactus`}
      signOutPath={`/${northernMortgageObject.path}/signout`}
    />
  ),
  children: [
    {
      path: `/${northernMortgageObject.path}`,
      element: (
        <Redirect redirectTo={`/${northernMortgageObject.path}/product`} />
      ),
    },
    {
      path: `/${northernMortgageObject.path}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={northernMortgageObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${northernMortgageObject.path}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${northernMortgageObject.path}/signout`,
      element: <SignOut />,
    },
  ],
};
